import React from 'react'
import RadiographyDrawer from '../../components/drawers/radiography'
import BilledQueue from '../../components/pages/billedQueue'

const Queue = () => {
    return <BilledQueue category="Radiography" basePath="/app/radiography/queue" DrawerComponent={RadiographyDrawer} />
}

export default Queue
